import React from "react";
import { Trans, useTranslation } from "react-i18next";

import deloitteLogo from "./images/deloitte.svg";
import deutscheBankLogo from "./images/deutschebank.svg";
import jpmorganLogo from "./images/jpmorgan.svg";
import kpmgLogo from "./images/kpmg.svg";

const partners = [
  { logo: deloitteLogo },
  { logo: kpmgLogo },
  { logo: deutscheBankLogo },
  { logo: jpmorganLogo },
];

const Partners = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-transparent">
      <div className="container text-center">
        <h5 className="mb-4 mt-4 text-black">
          <Trans i18nKey="partners.headline1" components={{ strong: <strong /> }} />
        </h5>
        <h5>{t("partners.headline2")}</h5>

        <div className="row justify-content-center m-5">
          {partners.map((partner, index) => (
            <div
              className="col-12 col-sm-6 col-md-3 mb-4"
              style={{ height: "70px" }}
              key={index}
            >
              <div className="card h-100 shadow-sm p-3 d-flex align-items-center justify-content-center">
                <img
                  src={partner.logo}
                  alt={`Partner ${index + 1}`}
                  className="img-fluid"
                  style={{
                    minWidth: "60%",
                    minHeight: "60%",
                    maxWidth: "80%",
                    maxHeight: "80%",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
